import React, { useEffect, useRef, useState } from "react";
import CIData from "./CIData";
import CITable from "./CITable";
import { getRows } from "./CIHelper";
import { getCurrentDate, getOnePreviousDate } from "../../Utilitie";
import SpeedAvgMaster from "./Speed Average/SpeedAvgMaster";
import Print from "../../Extra/Print";
import "../../../index.css";
import CIPunctualityData from "./CIPunctuality/CIPunctualityData";
import DownloadAsImage from "../../Extra/DownloadAsImage";
import SpeedMaster from "./Speed Average/SpeedMaster";

const CIMaster = () => {
  const printRef = useRef();
  const reportRef = useRef(null);

  const [apiData, setApiData] = useState(null);
  const [apiData1, setApiData1] = useState(null);
  const [apiData2, setApiData2] = useState(null);
  const [apiData3, setApiData3] = useState(null);
  const [apiData4, setApiData4] = useState(null);
  const [apiData5, setApiData5] = useState(null);
  const [apiData6, setApiData6] = useState(null);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(getOnePreviousDate());
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (
      apiData &&
      apiData1 &&
      apiData2 &&
      apiData3 &&
      apiData4 &&
      apiData5 &&
      apiData6
    ) {
      const rows = getRows(
        apiData,
        apiData1,
        apiData2,
        apiData3,
        apiData4,
        apiData5,
        apiData6,
      );
      setRows(rows);
    }
  }, [apiData, apiData1, apiData2, apiData3, apiData4, apiData5, apiData6]);
  return (
    <div>
      {" "}
      {/* <Print title={`CHC Report - ${date}`} printRef={printRef} /> */}
      <div>
        {" "}
        <DownloadAsImage reportRef={reportRef} title="dd" />
      </div>
      <div
        className="bg-dar text-white m-1"
        style={{ background: " rgba(0, 0, 50, 0.6)" }}
      >
        <b>CHC Report</b>{" "}
        <input
          type="date"
          value={date}
          max={getCurrentDate()}
          onChange={(e) => setDate(e.target.value)}
          className="m-1"
        />
      </div>
      <div className="row" ref={reportRef}>
        <div className="col-md-6">
          <CIData
            setApiData={setApiData}
            setApiData1={setApiData1}
            setApiData2={setApiData2}
            setApiData3={setApiData3}
            setApiData4={setApiData4}
            setApiData5={setApiData5}
            setApiData6={setApiData6}
            date={date}
          />
          <CITable rows={rows} date={date} />
        </div>

        <div className="col-md-5 newUiBody">
          <h6 className=" m-1">Speed HOR</h6> <SpeedMaster date={date} />
          <CIPunctualityData date={date} />
        </div>
      </div>
    </div>
  );
};
export default CIMaster;
